<div class="toasts app-column-auto gapped">
  @for ($toast of toastService.toasts(); track $toast) {
    <div class="toast app-column-auto toast-{{$toast.type}} rounded"
         (closeToast)="toastService.remove($toast)"
         (click)="toastService.remove($toast)"
    >
      <div class="toast-heading app-row centered-items padded">
        {{ $toast.header }}
      </div>
      <div class="toast-body padded app-column-auto gapped">
        @if (toastService.isSimpleToast($toast)) {
          <div [innerHTML]="$toast.body"></div>
        } @else if (toastService.isComponentToast($toast)) {
          <ng-container [ngComponentOutlet]="$toast.component" [ngComponentOutletInputs]="$toast.inputs"></ng-container>
        }
      </div>
    </div>
  }
</div>
